import { InternalAccessor } from '@billy/design-system'
import { ChangeEvent, useCallback, useState } from 'react'

interface UseProductUnitsModalParams {
  baseUnits: string[]
}

type ProductUnitTableItem = { id: string; unit: string; [InternalAccessor.HoverActions]: true }

export const useProductUnitsModal = ({ baseUnits }: UseProductUnitsModalParams) => {
  const [units, setUnits] = useState<ProductUnitTableItem[]>(
    baseUnits.map((unit) => ({ id: unit, unit, [InternalAccessor.HoverActions]: true })),
  )
  const [unitToDelete, setUnitToDelete] = useState<string | undefined>()
  const [lastUnitAdded, setLastUnitAdded] = useState<string | undefined>()
  const [unitToAdd, setUnitToAdd] = useState('')

  const handleUnitInputChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target
    setUnitToAdd(value)
  }, [])

  const handleAddUnitClick = useCallback(() => {
    const newUnit = {
      id: unitToAdd,
      unit: unitToAdd,
      [InternalAccessor.HoverActions]: true,
    } satisfies ProductUnitTableItem

    setUnits((units) => [...units, newUnit])
    setLastUnitAdded(newUnit.id)
    setUnitToAdd('')
  }, [unitToAdd])

  return {
    lastUnitAdded,
    unitToDelete,
    units,
    unitToAdd,
    handleAddUnitClick,
    handleUnitInputChange,
    setUnitToDelete,
    setUnits,
  }
}
